import React, { useState, useEffect } from "react";
import { Box, Fade } from "@mui/material";
import Header from "../Header";
import Footer from "../Footer";
import { TextComponent } from "./TextComponent";
import { TabbedContent } from "./TabbedContent";
import { ScrollToTopButton } from "../ScrollToTopButton";


export const Portfolio = () => {
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setFadeIn(true), 400); // Delay for fade-in effect
    return () => clearTimeout(timeout); // Cleanup timeout on unmount
  }, []);

  return (
    <Box sx={{ overflowX: "hidden" }}>
      <Header />
      <Box
        sx={{
          width: "100vw", // 화면 너비로 고정
          minHeight: "100vh", // 최소 높이를 화면 높이에 맞춤
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <TextComponent />
        <Box
          sx={{
            width: "100%", // TabbedContent의 너비
            minHeight: "400px", // TabbedContent의 예상 높이 (조정 가능)
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Fade in={fadeIn}>
            <div style={{ width: "100%" }}>
              <TabbedContent />
            </div>
          </Fade>
        </Box>
      </Box>
      <Footer />
      <ScrollToTopButton />
    </Box>
  );
};